export default async function(to, from, next) {
	const school = this.state.currentUser?.school;
	if (school?.features_live_help) {
		return next();
	} else {
		return next("/dashboard");
	}
}
